/**
 * ModalContainer Component
 * 
 * A component that creates a dedicated container for modals in the DOM
 * This ensures modals always appear on top of other content regardless of
 * stacking contexts or z-index issues in the app.
 */

import React, { useEffect } from 'react';

/**
 * ModalContainer component - creates a dedicated container for modals
 * that's guaranteed to be at the root level of the DOM
 * 
 * @returns {JSX.Element|null} - Returns null as this component doesn't render visible UI
 */
function ModalContainer() {
  useEffect(() => {
    // Check if the modal container already exists
    let modalRoot = document.getElementById('modal-root');
    
    // Create it if it doesn't exist
    if (!modalRoot) {
      modalRoot = document.createElement('div');
      modalRoot.id = 'modal-root';
      document.body.appendChild(modalRoot);
      
      // Apply styles to ensure it appears on top of everything
      modalRoot.style.position = 'fixed';
      modalRoot.style.top = '0';
      modalRoot.style.left = '0';
      modalRoot.style.width = '0';
      modalRoot.style.height = '0';
      modalRoot.style.overflow = 'visible';
      modalRoot.style.zIndex = '10000'; // Very high z-index
    }
    
    // Cleanup function
    return () => {
      // We intentionally don't remove the container on unmount
      // as other components might still need it
    };
  }, []);
  
  // This component doesn't render anything visible
  return null;
}

export default ModalContainer;
